(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bringIntoView(element) {
    if (!element) return;
    element.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    element.focus({ preventScroll: true });
  }

  document.querySelectorAll('[data-product-zone]').forEach(function (zone) {
    var form = zone.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var jump = zone.querySelector('[data-purchase-jump]');
    var finder = form.querySelector('[data-fit-finder-select]');
    var vehicle = form.querySelector('[data-vehicle-details]');
    var yearJump = form.querySelector('[data-fit-details-jump]');
    var note = form.querySelector('[data-fit-finder-note]');

    if (jump) {
      jump.addEventListener('click', function (event) {
        var choice = finder || form.querySelector('[data-option-fieldset] input[type="radio"]') || form.querySelector('[data-required-property]') || form.querySelector('[data-atc]');
        if (!choice) return;
        event.preventDefault();
        bringIntoView(choice);
      });
    }

    function syncYearJump() {
      if (!finder || !vehicle || !yearJump) return;
      var selected = !!finder.value && finder.value !== 'none' && finder.value !== '?';
      yearJump.hidden = !selected || /\b(?:19|20)\d{2}\b/.test(vehicle.value || '');
    }

    if (finder) {
      finder.addEventListener('change', function () {
        syncYearJump();
        if (!note || !vehicle || !yearJump || yearJump.hidden) return;
        var option = finder.options[finder.selectedIndex];
        // Only describe the model as filled in when the finder actually supplied this value.
        if (option && vehicle.value.trim() === (option.getAttribute('data-car') || '').trim()) {
          note.textContent = 'Suggested size: ' + finder.value + '. Model filled in below; add the four-digit year.';
        }
      });
    }
    if (vehicle) vehicle.addEventListener('input', syncYearJump);
    if (yearJump && vehicle) {
      yearJump.addEventListener('click', function () {
        bringIntoView(vehicle);
        if (vehicle.setSelectionRange) vehicle.setSelectionRange(0, 0);
      });
    }
    zone.addEventListener('change', syncYearJump);
    window.addEventListener('pageshow', syncYearJump);
    syncYearJump();
    zone.dispatchEvent(new Event('minkmods:purchase-update'));
  });
})();
